// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isUninstallTrackingAppsResult = objectOf({
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      type: string,
      uninstall_tracking_enabled: boolean,
    })
  ),
});
